import { NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, model, signal } from "@angular/core";

import { ModalComponent } from "@shared/components/modal/modal.component";

import { BaseModalComponent } from "../base-modal.component";

@Component({
  selector: "component-confirmation-modal",
  templateUrl: "./confirmation-modal.component.html",
  imports: [ModalComponent, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationModalComponent extends BaseModalComponent {
  readonly title = model.required<string>();
  readonly message = model.required<string>();
  readonly confirmText = model<string>("OK");
  readonly cancelText = model<string>("Cancel");
  // Optional multi-choice mode. If provided, footer will render choice buttons instead of confirm/cancel.
  readonly choices = model<
    {
      id: string;
      label: string;
      btnClass: string;
      buttonSize?: "sm" | "md" | "lg";
    }[]
  >([]);

  protected readonly icon = signal<any | null>(null);
  protected readonly iconCssClass = signal<string | null>(null);

  onConfirm(): void {
    this.activeModal.close(true);
  }

  onCancel(): void {
    this.activeModal.close(false);
  }

  onChoice(id: string): void {
    this.activeModal.close(id);
  }
}
